import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { buildAnchorLink } from '../../utils/helpers';

import AnchorPortrait from './AnchorPortrait';
import { Link } from 'react-router-dom';


function AnchorFanzone(props) {
  const { customStyles: styles, checkoutLink, classes, isDiscountPage } = props;
  const getAnchorLink = (anchor) => {
    if (isDiscountPage) {
      return checkoutLink(anchor);
    }

    return buildAnchorLink(anchor, '?filter=fanzone');
  };

  return (
    <React.Fragment>
      <div
        className={classnames(
          styles.anchorsContainer, { [`${styles.discountPage}`]: isDiscountPage }
        )}
      >
        <div className={`${styles.fanZoneAnchors} ${classes}`}>
          {props.fanzones.map((anchor) => (
            <Link
              key={anchor.id}
              className={styles.anchorContainer}
              to={getAnchorLink(anchor)}
            >
              <AnchorPortrait anchor={anchor} isDiscountPage={isDiscountPage} styles={styles} />
            </Link>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
}

export default AnchorFanzone;

AnchorFanzone.propTypes = {
  classes: PropTypes.string,
  fanzones: PropTypes.array.isRequired,
  isDiscountPage: PropTypes.func,
};
